import Vue from 'vue/dist/vue';
import { store } from 'js/modules/vue/store';
import { order } from 'js/modules/vue/modules/order-builder';

Vue.component('ccrr', {
    template: '#ccrr-template',
    computed: {
        searchTerm: function () {
            if (order.state.CrossReference.SelectedPart.Product) {
                return `${order.state.CrossReference.SelectedPart.Product.ManufacturerCode}, ${order.state.CrossReference.SelectedPart.Product.PartNumber}`;
            }
        },
        crossrefParts: function () {
            return order.state.CrossReference.Parts.filter((el) => {
                return !el.Inventory.Product.IsNLA;
            });
        },
        checked: function () {
            return order.state.Search.Type !== 'OB';
        },
    },
    methods: {
        hideCCRR: function () {
            store.commit('UpdateCrossReference', {
                Show: false,
                Parts: [],
                SelectedPart: order.state.Search.Part,
            });
            order.state.Search.Selected = false;
        },
    },
});
